module.exports = __webpack_public_path__ + "live-tip-clear-f707987a.png";